import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';

import { SupplierTableFilterSchema } from './-zod-schema';

export const Route = createFileRoute('/_staff/supplier/_list/')({
  validateSearch: zodValidator(SupplierTableFilterSchema),
});
